import { render } from "./iconCart.vue?vue&type=template&id=5aa1b9af"
import script from "./iconCart.vue?vue&type=script&lang=js"
export * from "./iconCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__